<app-header></app-header>
<app-nav *ngIf="menu.isMenuVisible | async"></app-nav>
<div class="main-layout">
  <div class="container">
      <router-outlet></router-outlet>
  </div>
</div>
